import * as React from 'react';

const SvgChatSend = (props) => (
  <svg
    width={32}
    height={32}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.997 2.667C8.637 2.667 2.664 8.64 2.664 16s5.973 13.333 13.333 13.333S29.331 23.36 29.331 16 23.357 2.667 15.997 2.667Zm5.374 14.04-4 4c-.2.2-.454.293-.707.293a.989.989 0 0 1-.707-.293 1.006 1.006 0 0 1 0-1.414L18.251 17h-6.92c-.547 0-1-.453-1-1 0-.547.453-1 1-1h6.92l-2.294-2.293a1.006 1.006 0 0 1 0-1.414 1.006 1.006 0 0 1 1.414 0l4 4a1.006 1.006 0 0 1 0 1.414Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgChatSend;
